<template>
  <v-footer padless>
    <v-container fluid class="pa-0 mt-12">
      <v-row justify="center" class="text-left my-12">
        <!-- <v-col cols="12" md="5" class="mr-md-8">
          <h3>Centro Multidisciplinar Fluminense</h3>
          <p>Fundado em 2012, o Centro Multidisciplinar Fluminense tornou-se referência em saúde, principalmente na área de reumatologia. Venha consultar-se onde sua saúde vem em primeiro lugar!</p>
        </v-col> -->
        <v-col cols="12" md="4" class="midias text-center">
          <h3>Acompanhe nossa mídias sociais</h3>
          <v-row class="py-4 px-8" justify="center">
            <v-col v-for="(midia, i) in midias" :key="i" cols="4">
              <a :href="midia.link" target="_blank">
                <v-icon large color="black">{{ midia.icon }}</v-icon>
              </a>
            </v-col>
          </v-row>
        </v-col>
        <!-- <v-col cols="12" md="4">
          3
        </v-col> -->
      </v-row>
      <v-row justify="center" align-content="center" no-gutters >
        <v-col class="py-4 text-center" cols="12" md="5">
          <strong>{{ new Date().getFullYear() }}</strong> {{ siteName }}
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="3">
          <a href="https://agencia352.com" target="_blank">
            <v-img src="@/assets/352.png" position="center" width="100%" contain max-height="25px" ></v-img>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'FooterAlt',
  data(){
    return{
      siteName: 'Centro Multidisciplinar Fluminense',
      midias: [
        { icon: 'fab fa-facebook', link: 'https://www.facebook.com/CentroMultidisciplinarFluminense/'},
        { icon: 'fab fa-instagram', link: 'https://www.instagram.com/centrofluminense/'},
        // { icon: 'fab fa-youtube', link: 'https://www.youtube.com/channel/UCKZh6kxKg_c07WszLDZK_Tg'},
      ],
    }
  }
}
</script>

<style lang="scss">
.v-footer{
  background-color: transparent !important;
  // margin-top: 100px;

  p{
    font-size: .9em;
  }
  .midias{

    a{
      text-decoration: none;
    }
  }
  .v-image__image{
    // filter: brightness(0) invert(.2);
  }
}
</style>